import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  ControlContainer,
  NgForm
} from '@angular/forms';

import { CompanyService }        from '../../../companies/company.service';
import { NewVehicleFieldsModel } from './typings/new-vehicle-fields';

// The rego, make, model and colour typed in to add a vehicle from a form, the rego under the company's own label
@Component({
  selector   : 'wor-new-vehicle-fields',
  styles: [ require('./new-vehicle-fields.component.scss') ],
  template: require('./new-vehicle-fields.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class NewVehicleFieldsComponent {
  @Input() giveFocus : boolean = false;
  @Input() name      : string  = 'new-vehicle';
  @Input() vehicle   : NewVehicleFieldsModel;

  @Output() vehicleChange : EventEmitter<NewVehicleFieldsModel> = new EventEmitter();

  constructor (
    private companyService : CompanyService
  ) {}

  get regoLabel () : string {
    return this.companyService.labels.rego;
  }

  onFieldChange ( field : keyof NewVehicleFieldsModel, value : string ) : void {
    this.vehicleChange.emit({
      ...this.vehicle,
      [field]: value
    });
  }
}
